import {useState} from "react";
import IconButton from '@mui/material/IconButton';
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { FTOTableData } from "./GetFTOtable";
import IconButtonSetting from "../../../../../../../components/Button/IconButtonSetting";

export default function Dia_FTO_Variants() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      
        <IconButton onClick={handleOpen} size="small">
            <IconButtonSetting />
        </IconButton>


        <CustomDialog open={open} onClose={handleClose}

        title='FAT Gene - FTO Variants'

        content={ <FTOTableData />}
      
        />

</>
)}